// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaInstagram_root__1R4Od"};